import React from 'react'
import { useFormikContext } from 'formik'
import { useTranslation } from 'react-i18next'
import Typography from '@mui/material/Typography'
import Grid from '@mui/material/Grid'
import { Alert } from '@carsys/ui/src/Alert'
import { Checkbox, Dropdown, TextField } from '@carsys/form'
import { InvoiceType, InvoiceTypeWithVehicleSales } from '@cbgms/api/modules/enums'
import { enumToOptions } from '@cbgms/base/utils/helpers'
import { PERMISSION_VEHICLESALES_READ } from 'utils/Subscription/Permissions'
import { useHasPermission } from 'utils/Subscription/RequiredPermissions'
import { FormValues } from './Types.d'

export const InvoiceSequenceFields: React.FC<{}> = () => {
  const { t } = useTranslation()
  const { values } = useFormikContext<FormValues>()
  const [hasVehicleSalesPermission] = useHasPermission(PERMISSION_VEHICLESALES_READ)
  const invoiceTypeOptions = enumToOptions(hasVehicleSalesPermission ? InvoiceTypeWithVehicleSales : InvoiceType, 'EnumInvoiceType')

  const readOnly = !values.IsUpdatable

  return (
    <>
      <Grid item xs={12}>
        {readOnly && (
          <Alert severity='warning' title={t('global.warning')}>
            <Typography>{t('invoice_sequence.not_updatable')}</Typography>
          </Alert>
        )}
      </Grid>
      <Grid item xs={12}>
        <Checkbox label={t('invoice_sequence.automated_invoice_number_renewal')} name='AutomatedInvoiceNumberRenewal' />
      </Grid>
      <Grid item xs={4}>
        <Dropdown
          label={t('invoice_sequence.invoicetype')}
          data-testid='InvoiceType-dropdown'
          name='InvoiceType'
          options={invoiceTypeOptions}
          required
          fullWidth
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label={t('invoice_sequence.year')}
          data-testid='invoice-sequence-year'
          name='Year'
          required
          fullWidth
          type='number'
          onKeyPress={event => {
            if (!/[0-9]/.test(event.key)) {
              event.preventDefault()
            }
          }}
          inputProps={{ readOnly }}
        />
      </Grid>
      <Grid item xs={4}>
        <TextField
          label={t('invoice_sequence.nextnumber')}
          data-testid='invoice-sequence-next-number'
          name='NextNumber'
          fullWidth
          type='number'
          inputProps={{ readOnly }}
        />
      </Grid>
    </>
  )
}
